<template>
    <div class="footer">
<!--        Footer-->
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'Footer',
    props: ['result'],
    methods: {
        ...mapActions({
            getBackBasketItems: 'basket/getBackBasketItems',
        }),
        removeIPostDataFromStorage() {
            this.getBackBasketItems();
        }
    },
    created() {
        this.removeIPostDataFromStorage();
    },
}
</script>

<style lang="scss" scoped>
.footer{

}
</style>